// Async boundary required by Module Federation: deferring the real entry into a
// dynamic import lets the shared scope (react, react-dom, react-router-dom)
// initialize before any shared module is consumed. See FINTELLA_ONBOARDING_PLAN.md.
import("./bootstrap");

export {};
